"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('setup.languages', function () {
    this.load = function (visuals, deferred) {
        namespace_1.default.debug.showInfo('Loading languages');
        var defArr = [];
        visuals.forEach(function (visual) {
            var language = 'de';
            var defObj = jquery_1.default.Deferred();
            var loader = new namespace_1.default.loader.language();
            var namespace = visual.toString();
            if (namespace_1.default.visual[namespace].config.language) {
                language = namespace_1.default.language.getLanguage(namespace_1.default.visual[namespace].config.language);
            }
            else {
                namespace_1.default.visual[namespace].config.language = 'deu';
            }
            defArr.push(defObj);
            var tPath = namespace_1.default.params.paths.apa.language;
            loader.setOptions({
                jsonpCallback: 'apaCallbackLang' + namespace_1.default.formatting.firstUpperCase(namespace),
                url: tPath + '/' + namespace + '.' + language + '.js?cb=' + namespace_1.default.params.cachebreaker,
                deferred: defObj,
            });
            loader.namespace = namespace;
            loader.load();
        });
        jquery_1.default.when.apply(this, defArr).then(function () {
            deferred.resolve();
        });
    };
});
